<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <KTCodePreview v-bind:title="`Komponen Penilaian - ${bread}`">
          <template v-slot:body>
            <b-form>
              <div class="d-flex flex-row-reverse align-items-center">
                <button type="button" class="btn-blue-sub" @click="addRow" style="z-index: 1;">
                  <b-icon icon="plus-circle" scale="1" variant="default"></b-icon>&nbsp;Tambah Komponen
                </button>
              </div>
              <div class="mt-3">
                <table class="formKomponenNilai-table" style="">
                  <thead>
                    <tr>
                      <th>
                        <center>Komponen Nilai</center>
                      </th>
                      <th v-if="name != 'jasmani'">
                        <center>Bobot Komponen</center>
                      </th>
                      <th>
                        <center>Aksi</center>
                      </th>
                    </tr>
                  </thead>
                  <tbody id="tbody_tambahDikreg">
                    <template v-for="(tableData, index) in scoreRanges">
                      <tr :key="index" :id="'row_' + index">
                        <!-- <td v-if="name == 'jasmani' || name == 'kepribadian'">
                          <SelectComponent :data="aspects" :changeSelected="changeAspect(index, $event)" :models="tableData.component"></SelectComponent>
                          <b-form-group>
                            <Select2 v-model="tableData.component" :options="aspects" @change="changeAspect(index, $event)" :settings="{  width: '100%' }" />
                          </b-form-group>
                        </td> -->
                        <!-- <td v-else> -->
                        <td>
                          <center><b-form-input class="input-table" :id="'komponen_nilai' + index"
                              v-model="tableData.component" type="text" required></b-form-input></center>
                        </td>
                        <!-- </td> -->
                        <td  v-if="name != 'jasmani'">
                          <center><b-form-input class="input-table" :id="'bobot_komponen' + index"
                              v-model="tableData.weights" type="text" required></b-form-input></center>
                              <p class="text-danger" v-if="parseInt(tableData.weights) > parseInt(maxx_weight)">*)Maksimal {{ maxx_weight }}</p> 
                        </td>
                        <td style="padding: 5px;">
                          <center>
                            <ButtonComponent colors="#EF4848" name="hapus"
                              @click.native="deleteRow(tableData.key, index)">
                            </ButtonComponent>
                          </center>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>

              <div class="row mt-5">
                <div class="col-6"><!-- empty space for div --></div>
                <div class="col-2 offset-4" style="display: flex;">
                  <b-button variant="outline-primary" style="margin-left: auto;" @click="submit">Simpan</b-button>
                  <b-button variant="outline-danger" style="margin-left: auto;" @click="changeurl()">Back</b-button>
                </div>
              </div>
            </b-form>
          </template>
        </KTCodePreview>
      </div>
    </div>
  </div>
</template>

<style scoped>
.input-table {
  font-weight: bold;
  text-align: center;
}

.square {
  background: linear-gradient(90.22deg, #829DFF 0.61%, #B490CA 99.48%);
  height: 52px;
}

.garis {
  border-right: 1px solid white;
  top: 10px;
  height: 15%;

}
</style>

<style lang="scss">
.input-table {
  width: 85%;
}

.btn-blue-sub {
  box-sizing: border-box;
  height: 30px;
  min-width: 104px;
  padding: 0 16px;

  background: #D9DEFF;
  border: 0.5px solid #3751E4;
  border-radius: 4px;

  color: #3751E4 !important;
}

.btn-blue-sub:hover {
  background-color: #3751E4;
  color: white !important;
}

.formKomponenNilai-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 1em;
}

.formKomponenNilai-table>thead>tr>th {
  height: 40px;
  background-color: #3751E4;
  color: white
}
</style>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import KTCodePreview from "@/view/content/CardContent.vue";
import ButtonComponent from "@/view/content/components/button/buttonComponent.vue";
import axios from 'axios';
// import SelectComponent from "@/view/content/components/select/SelectComponent.vue";

export default {
  props: {
    propsScoreComponent: Object
  },
  data() {
    return {
      request: {
        key: null,
        prodi_id: null,
        matkul_id: null,
        sks: null,
        id_tahun: null,
        id_angkatan: null,
        id_prodi: null,
        semester: null
      },
      scoreRanges: [],
      counter: 0,
      id: '',
      name: '',
      maxxWeights: '',
      maxx_weight: [],
      aspect_key: [],
      aspects: [],
      prodi: [
        { id: null, text: '-- Select Prodi --' }
      ],
      tahunakademik: [
        { id: null, text: '-- Select Tahun Akademik --' }
      ],
      selectedTahunAkademik: null,
      selectedProdi: null,
      dynamicParam: null,
      semester: [],
      dataProdi: [],
      dataAngkatan: [],
      dataTahun: [],
      bread: '',
      headers: [
          { text: "No", value: "no" },
          { text: "Kode Matkul", value: "kode" },
          { text: "MatKul", value: "matkul" },
          { text: "Aksi", value: "action" }
      ],
      jasmani: [],
      statusJasmani: false,
    }
  },
  components: {
    KTCodePreview,
    ButtonComponent,
    // SelectComponent
  },
  async mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Penilaian Siswa" },
      { title: "Komponen Penilaian Detail" }
    ]);
    
    this.id = this.$route;
    
    let na = this.$route.path.split('/');
    this.name = na[3];
    
    this.bread = this.name[0].toUpperCase() + this.name.slice(1)
    await this.loadData(this.name);
    // Initialize the component with the initial dynamic parameter
    this.dynamicParam = this.$route.params.uuid;

  },
  methods: {
    async loadData(name){
      if (name == 'jasmani') {
        const data1 = this.getData();
  
        await Promise.all([data1])
      }else{
        const data1 = this.getData();
        const data2 = this.getdataMaxx();
  
        await Promise.all([data1,data2])
      }
    },
    async getData() {
      try {
        
        let result = await axios.get(`penilaian-jasmani-new/komponen-bobot-detail?prodi=${this.propsScoreComponent.prodi}&angkatan=${this.propsScoreComponent.angkatan}&matkul=${this.propsScoreComponent.course_key}`);
        let sum = 0;
        result.data.data.forEach(function (item) {
          sum += (parseFloat(item.weights));
        });
        this.maxxWeights = sum;
        
        this.scoreRanges = result.data.data.map(x => ({ 'key': x.key, 'component': x.nama_bobot, 'weights': x.nilai_bobot }))
      } catch (err) {
          // this.$swal(`Failed`);
      }
    },

    async getDataTahun() {
      if (this.dataTahun) {
        this.dataTahun = [];
      }
      await axios.get('master/generations')
        .then(response => {
          if (response.status == 200) {
              response.data.data.map((e, index) => {
                if(e.status) {
                    var object = { "id": e.key, "text": e.tahun + " / " + e.tahun_akhir + " " + e.semester }
                    this.dataTahun.push(object);
                }
                return index > e.length;
              });
          }
        })
        this.sortedTahun()
    },
    sortedTahun() {
        return this.dataTahun.sort((a, b) => {
          if (a.id && b.id) {
            if (b.text < a.text) return -1;
            if (b.text > a.text) return 1;
            return 0;
          }
        });
    },

    async getDataAngkatan(){
      if (this.dataAngkatan) {
        this.dataAngkatan = []
      }
      await axios.get('master/angkatan?status=true')
        .then(res => {
          res.data.data.map((angkatans, index) => {
            if (res.status) {
              let angkatan = {id: angkatans.key, text: angkatans.nama_angkatan};
              this.dataAngkatan.push(angkatan);
            }
            return index > angkatans.length
          })
        })
        this.sortedDes();
    },
    sortedDes() {
        return this.dataAngkatan.sort((a, b) => {
          if (a.id && b.id) {
            if (b.text < a.text) return -1;
            if (b.text > a.text) return 1;
            return 0;
          }
        });
    },

    async getDataProdi() {
      let res = await axios.get('krs-new/get-all');
      const array = res.data.data;

      const key = 'program_name';

      const arrayUniqueByKey = [...new Map(array.map(item =>
        [item[key], item])).values()];

      this.temp = array;
      arrayUniqueByKey.map((arr) => {
          var object = { id: arr.prodi, text: arr.program_name }
          this.dataProdi.push(object);
      })
    },

    
    async getDataSemester(angkatan,prodi_id,generation){
      if (this.semester.length) {
        this.semester = [];
      }
      await axios.get(`master/schedule/${prodi_id}/${angkatan}/${generation}/krs`)
      .then(res => {
        res.data.data.map((sem,index) => {
          let semesters = {id: sem.key, text: sem.semester};
          this.semester.push(semesters)
          return index > sem.length
        })
      })

      this.sortedSemester()
    },
    sortedSemester() {
      return this.semester.sort((a, b) => {
        if (a.id && b.id) {
          if (a.text < b.text) return -1;
          if (a.text > b.text) return 1;
          return 0;
        }
      });
    },

    async changeprodi(selected) {
      this.request.id_prodi = selected;
      this.request.id_angkatan = null;
      this.request.id_tahun = null;
      this.request.semester = null;
      await this.getDataAngkatan(selected);
    },

    async changegeneration(selected) {
      this.request.id_angkatan = selected;
      this.request.id_tahun = null;
      this.request.semester = null;
      this.request.id_matakuliah = null;
    },

    async changeTahun(selected) {
      this.request.id_tahun = selected
      if (this.request.id_prodi && this.request.id_angkatan) {
        await this.getDataSemester(this.request.id_angkatan, this.request.id_prodi, this.request.id_tahun)
      }
    },

    async changeSemester(selected) {
      this.request.semester = selected
      if (this.request.id_prodi && this.request.id_angkatan && this.request.id_tahun) {
        await this.getData()
      }
    },

    async getdataMaxx(){
      const maxx = await axios.get(`master/max-weights`);
      var aspek = '';
      if (this.name === 'pengpil') {
        aspek = 'ASPEK PENGETAHUAN DAN KETERAMPILAN'
      }else if(this.name === 'jasmai'){
        aspek = 'ASPEK JASMANI'
      }else if (this.name === 'sikku') {
        aspek = 'ASPEK SIKAP DAN PERILAKU'
      }
      let hasil = maxx.data.data.find(max => max.aspect == aspek);
      this.maxx_weight = hasil.max_weight;
    },


    addRow() {
      this.scoreRanges.push({
        key: null,
        component: null,
        weights: null,
      });
      // this.getdataAspect();
    },
    async deleteRow(dataKey, index) {
      try {
        if (dataKey) {

          this.$swal({
            title: 'Are you sure?',
            text: 'You will not be able to recover this item!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33'
          }).then(async (result) => {
            if (result.value) {
              // User confirmed, so delete the item
              let result = null
              if (this.name == 'pengpil') {
                result = await axios.delete(`penilaian-akademik-new/komponen-bobot/${dataKey}/`)
              } else if (this.name == 'jasmani') {
                result = await axios.delete(`penilaian-jasmani-new/komponen-bobot/${dataKey}/`)
              } else if (this.name == 'sikku') {
                result = await axios.delete(`penilaian-kepribadian-new/komponen-bobot/${dataKey}/`)
              }
              if (result.data.meta.code == 200) {
                this.$swal('Berhasil', 'Bobot Komponen Berhasil Dihapus!', 'OK');
                this.$delete(this.scoreRanges, index);
              }
            } else {
              // User canceled, so do nothing
            }
          })
        } else {
          if (index > 0) {
            this.$delete(this.scoreRanges, index);
          }
        }
      } catch (err) {
          this.$swal(`Failed`);
      }
    },

    async submit() {
      let successCount = 0;
      const total = this.scoreRanges.length;
      
      // Menyimpan status pengiriman data
      const status = new Array(total).fill(false);
      this.scoreRanges.forEach(async (scoreRange, index) => {
          try {
            let formData = {
              uuid: scoreRange.key,
              nama_bobot: scoreRange.component,
              nilai_bobot: scoreRange.weights,
              tahun_akademik: this.scoreComponent.key_generation,
              prodi: this.scoreComponent.prodi,
              course: this.scoreComponent.course_key,
              angkatan: this.scoreComponent.angkatan,
            };
              let result = await axios.post(`penilaian-jasmani-new/komponen-bobot/createorupdate`, formData)
              if (result.data.meta.code != 200) {
                this.$swal('Gagal', 'Bobot Komponen Gagal Disimpan!', 'OK');
              }
              successCount++;
          } catch (err) {
            this.$swal(`Failed`);
          }
        // Menandai status pengiriman berhasil
      status[index] = true;
        if (successCount === total) {
            this.$swal('Berhasil', 'Bobot Komponen Berhasil Disimpan!', 'OK');
            this.getData()
          }
      });
    },

    refreshPage() {
      this.$router.go(0);
    },
    changeurl() {
        // ganti url
        this.$router.push({name: 'komponen-penilaian-jasmani'});
    },
  },
  computed: {
    aspectName() {
      return this.$route.params != null ? this.$route.params.name.charAt(0).toUpperCase() + this.$route.params.name.slice(1) : 'Komponen Statis'
    },
    aspectKey() {
      return this.$route.params != null ? this.$route.params.uuid : null
    },
    scoreComponent() {
      return this.propsScoreComponent != null ? this.propsScoreComponent : this.$store.getters.getStateKomponenNilai;
    },
    isAnyInputMoreThan1000() {
      for (const tableData of this.scoreRanges) {
        if (parseInt(tableData.weights) > 1000) {
          return true;
        }
      }
      return false;
    },
    checkSelectJasmani(){
      return !!(this.request.id_prodi && this.request.id_angkatan)
    },
  },
  watch: {
    '$route.name': 'refreshPage',
    'request.id_prodi': 'getData',
    'request.id_angkatan': 'getData'
  },
}
</script>
